import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-get-help',
  templateUrl: './get-help.component.html',
  styleUrls: ['./get-help.component.scss']
})
export class GetHelpComponent implements OnInit {
  option: any = '';

  constructor() {
  }

  ngOnInit(): void {
  }

  scrollTo(item) {

    const yOffset = -80;
    const element = document.getElementById(item);
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({top: y, behavior: 'smooth'});
  }

  onOptionChange(e) {
    this.scrollTo(e)
  }
}
